// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyBkXPl9HR06TGtg0_HMkhbgra8QeEDxs-A",
  authDomain: "ietkd-study.firebaseapp.com",
  projectId: "ietkd-study",
  storageBucket: "ietkd-study.appspot.com",
  messagingSenderId: "940583520169",
  appId: "1:940583520169:web:228c742757bf336ad3e6b8",
  measurementId: "G-10P7QMS7ZL"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);